import { render, staticRenderFns } from "./FiltroTipoPedido.vue?vue&type=template&id=3e4d43b4&"
import script from "./FiltroTipoPedido.vue?vue&type=script&lang=js&"
export * from "./FiltroTipoPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports